import React from 'react';

import './index.scss';

function TransformInput(props) {

  var hover = props.hover || {};

  function parseInputValue(rawValue) {
    var parsed = parseFloat(rawValue);
    if (isNaN(parsed) === true) {
      return 0;
    }
    return parsed;
  }

  function handleTranslateChange(axis, event) {
    var value = parseInputValue(event.target.value);
    var current = hover.translate || { x: 0, y: 0, z: 0 };
    var updated = { x: current.x, y: current.y, z: current.z };
    updated[axis] = value;
    props.onChange('translate', updated);
  }

  function handleScaleChange(axis, event) {
    var value = parseInputValue(event.target.value);
    var current = hover.scale || { x: 1, y: 1, z: 1 };
    var updated = { x: current.x, y: current.y, z: current.z };
    updated[axis] = value;
    props.onChange('scale', updated);
  }

  function handleRotateChange(axis, event) {
    var value = parseInputValue(event.target.value);
    var current = hover.rotate || { x: 0, y: 0, z: 0 };
    var updated = { x: current.x, y: current.y, z: current.z };
    updated[axis] = value;
    props.onChange('rotate', updated);
  }

  function handleSkewChange(axis, event) {
    var value = parseInputValue(event.target.value);
    var current = hover.skew || { x: 0, y: 0 };
    var updated = { x: current.x, y: current.y };
    updated[axis] = value;
    props.onChange('skew', updated);
  }

  function handlePerspectiveChange(event) {
    var value = parseInputValue(event.target.value);
    props.onChange('perspective', value);
  }

  function handleClearProperty(property) {
    props.onChange(property, null);
  }

  function renderSectionHeader(label, unit, property) {

    var hasValue = (hover[property] !== void 0 && hover[property] !== null);

    var clearButton = null;
    if (hasValue === true) {
      clearButton = <button
        className="transform-section-clear-button"
        onClick={handleClearProperty.bind(null, property)}
      >Clear</button>;
    }

    var displayLabel = label;
    if (unit !== null) {
      displayLabel = label + ' (' + unit + ')';
    }

    return <div className="transform-section-header">
      <span className="transform-section-label">{displayLabel}</span>
      {clearButton}
    </div>;

  }

  function renderNumberInput(label, value, step, onChangeHandler) {

    var inputAttributes = {
      type: 'number',
      className: 'transform-number-input',
      value: value,
      step: step,
      onChange: onChangeHandler
    };

    return <div className="transform-input-field">
      <label className="transform-field-label field-label">{label}</label>
      <input {...inputAttributes} />
    </div>;

  }

  function renderTranslateSection() {

    var translate = hover.translate || { x: 0, y: 0, z: 0 };

    return <div className="transform-section">
      {renderSectionHeader('Translate', 'px', 'translate')}
      <div className="transform-inputs-row">
        {renderNumberInput('X', translate.x, 1, handleTranslateChange.bind(null, 'x'))}
        {renderNumberInput('Y', translate.y, 1, handleTranslateChange.bind(null, 'y'))}
        {renderNumberInput('Z', translate.z, 1, handleTranslateChange.bind(null, 'z'))}
      </div>
    </div>;

  }

  function renderScaleSection() {

    var scale = hover.scale || { x: 1, y: 1, z: 1 };

    return <div className="transform-section">
      {renderSectionHeader('Scale', null, 'scale')}
      <div className="transform-inputs-row">
        {renderNumberInput('X', scale.x, 0.1, handleScaleChange.bind(null, 'x'))}
        {renderNumberInput('Y', scale.y, 0.1, handleScaleChange.bind(null, 'y'))}
        {renderNumberInput('Z', scale.z, 0.1, handleScaleChange.bind(null, 'z'))}
      </div>
    </div>;

  }

  function renderRotateSection() {

    var rotate = hover.rotate || { x: 0, y: 0, z: 0 };

    return <div className="transform-section">
      {renderSectionHeader('Rotate', 'deg', 'rotate')}
      <div className="transform-inputs-row">
        {renderNumberInput('X', rotate.x, 1, handleRotateChange.bind(null, 'x'))}
        {renderNumberInput('Y', rotate.y, 1, handleRotateChange.bind(null, 'y'))}
        {renderNumberInput('Z', rotate.z, 1, handleRotateChange.bind(null, 'z'))}
      </div>
    </div>;

  }

  function renderSkewSection() {

    var skew = hover.skew || { x: 0, y: 0 };

    return <div className="transform-section">
      {renderSectionHeader('Skew', 'deg', 'skew')}
      <div className="transform-inputs-row">
        {renderNumberInput('X', skew.x, 1, handleSkewChange.bind(null, 'x'))}
        {renderNumberInput('Y', skew.y, 1, handleSkewChange.bind(null, 'y'))}
      </div>
    </div>;

  }

  function renderPerspectiveSection() {

    var perspective = hover.perspective || 0;

    return <div className="transform-section">
      {renderSectionHeader('Perspective', 'px', 'perspective')}
      <div className="transform-inputs-row">
        {renderNumberInput('Value', perspective, 10, handlePerspectiveChange)}
      </div>
    </div>;

  }

  function renderMain() {

    return <div className="transform-input-main">
      {renderTranslateSection()}
      {renderScaleSection()}
      {renderRotateSection()}
      {renderSkewSection()}
      {renderPerspectiveSection()}
    </div>;

  }

  return renderMain();

}

export default TransformInput;